import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { AppTheme } from './styles/AppTheme';
import { StyleSheet, css } from 'aphrodite';
import { Controller } from './common/Controller';
import { UiHelper } from './common/helpers/UiHelper';
import { Header } from './components/Header';
import { PublicFooter } from './components/PublicFooter';
import { PublicHeader } from './components/PublicHeader';
import { DashboardAdmin } from './screens/DashboardAdmin';
import { Numbers } from './screens/admin/Numbers';
import { Partners } from './screens/admin/Partners';
import { News } from './screens/admin/News';
import { Banners } from './screens/admin/Banners';
import { ProductImages } from './screens/admin/ProductImages';
import { ProductsByBrand } from './screens/admin/ProductsByBrand';
import { Params } from './screens/admin/Params';
import { ProdListItems } from './screens/admin/ProdListItems';
import { ProdLists } from './screens/admin/ProdLists';
import { Brands } from './screens/admin/Brands';
import { CatsL1 } from './screens/admin/CatsL1';
import { CatsL2 } from './screens/admin/CatsL2';
import { CatsL3 } from './screens/admin/CatsL3';
import { Products } from './screens/admin/Products';
import { Product } from './screens/admin/product/Product';
import { ProductsByCat } from './screens/admin/ProductsByCat';
import { Orders } from './screens/admin/Orders';
import { ProductDocs } from './screens/admin/ProductDocs';
import { ProductDetails } from './screens/ProductDetails';
import { CatProducts } from './screens/CatProducts';
import { CompareProducts } from './screens/CompareProducts';
import { Search } from './screens/Search';
import { Groups } from './screens/Groups';
import { About } from './screens/About';
import { ComingSoon } from './screens/ComingSoon';
import { BrandInfo } from './screens/BrandInfo';
import { LoginPage } from './screens/LoginPage';
import { NotFound } from './screens/NotFound';
import { Terms } from './screens/Terms';
import { Privacy } from './screens/Privacy';
import { Home } from './screens/Home';
import { ProductLegacy } from './screens/ProductLegacy';
import { Orgs } from './screens/admin/Orgs';
import { UsersOfOrg } from './screens/admin/UsersOfOrg';
import { InventoryOfOrg } from './screens/admin/InventoryOfOrg';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: AppTheme.primaryColor
    },
    secondary: {
      main: AppTheme.secondaryColor
    }
  },
  typography: {
    fontFamily: [
      'Nunito',
    ].join(',')
  }
});

const PublicRoute = (props) => {
  if (Controller.get().loginMgr().getCurrentUser()) {
    if (props && props.path === '/login') {
      return <Redirect to={Controller.get().getHomeByRole()} />
    }
  }
  return <Route {...props} />
}

const ProtectedRoute = (props) => {
  if (Controller.get().loginMgr().getCurrentUser()) {
    if (props.userLoaded) {
      return <Route {...props} />
    }
    Controller.get().loginMgr().bootstrap((err, data) => {
      if (err) {
        console.error('bootstrap err:', err)
        return
      }
      props.setUserLoaded && props.setUserLoaded()
    })
    return (
      UiHelper.componentLoadingView()
    )
  } else {
    return <Redirect to='/login' />
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: Controller.get().loginMgr().getCurrentUser()
    };
  }

  setUserLoaded = () => {
    this.setState({
      userLoaded: true,
      currentUser: Controller.get().loginMgr().getCurrentUser()
    })
  }

  render() {
    return (
      <Router>
        <MuiThemeProvider theme={theme}>
          <Route path={'/'} component={({ location, history }) => {
            return (
              <div className={css(Styles.page)}>
                {/*this.state.currentUser &&
                  Controller.get().userMgr().isProductSU() &&
                  <Header
                    history={history}
                    className={css(Styles.header)}
                    currentUser={this.state.currentUser}
                    homeLink={this.getUserHomeLink()}
                    onDashboardClick={() => this.onDashboardClick()}
                    onLogoutClick={() => this.onLogoutClick()} />
                */}

                {history.location.pathname !== '/login' &&
                  <PublicHeader
                    history={history}
                    onDashboardClick={() => this.onDashboardClick()}
                    currentUser={this.state.currentUser}
                    className={css(Styles.header)}
                    onLogoutClick={() => this.onLogoutClick()} />
                }

                <div
                  className={css(Styles.content)}>
                  {this.renderRoute(history)}
                </div>

                {!Controller.get().userMgr().isProductSU() &&
                  history.location.pathname !== '/login' &&
                  <PublicFooter className={css(Styles.footer)} />
                }
              </div>
            );
          }}
          />
        </MuiThemeProvider>
      </Router>
    );
  }

  renderRoute(history) {
    window.scrollTo(0, 0)
    Controller.get().setNavigator(history);
    const props = {
      userLoaded: this.state.userLoaded,
      setUserLoaded: this.setUserLoaded
    }
    return (
      <Switch>
        <ProtectedRoute {...props} exact path={'/admin'} component={DashboardAdmin} />
        <ProtectedRoute {...props} exact path={'/admin/products/:id/images'} component={ProductImages} />
        <ProtectedRoute {...props} exact path={'/admin/products/:id/docs'} component={ProductDocs} />
        <ProtectedRoute {...props} exact path={'/admin/products/:id'} component={Product} />
        <ProtectedRoute {...props} exact path={'/admin/products'} component={Products} />
        <ProtectedRoute {...props} exact path={'/admin/orders'} component={Orders} />
        <ProtectedRoute {...props} exact path={'/admin/partners'} component={Partners} />
        <ProtectedRoute {...props} exact path={'/admin/numbers'} component={Numbers} />
        <ProtectedRoute {...props} exact path={'/admin/news'} component={News} />
        <ProtectedRoute {...props} exact path={'/admin/banners'} component={Banners} />
        <ProtectedRoute {...props} exact path={'/admin/brands/:id'} component={ProductsByBrand} />
        <ProtectedRoute {...props} exact path={'/admin/brands'} component={Brands} />
        <ProtectedRoute {...props} exact path={'/admin/cats/:idl1/:idl2/:idl3/params'} component={Params} />
        <ProtectedRoute {...props} exact path={'/admin/cats/:idl1/:idl2/:idl3/products'} component={ProductsByCat} />
        <ProtectedRoute {...props} exact path={'/admin/cats/:idl1/:idl2'} component={CatsL3} />
        <ProtectedRoute {...props} exact path={'/admin/cats/:idl1'} component={CatsL2} />
        <ProtectedRoute {...props} exact path={'/admin/cats'} component={CatsL1} />
        <ProtectedRoute {...props} exact path={'/admin/prod-lists/:id'} component={ProdListItems} />
        <ProtectedRoute {...props} exact path={'/admin/prod-lists'} component={ProdLists} />
        <ProtectedRoute {...props} exact path={'/admin/orgs'} component={Orgs} />
        <ProtectedRoute {...props} exact path={'/admin/orgs/:id/users'} component={UsersOfOrg} />
        <ProtectedRoute {...props} exact path={'/admin/orgs/:id/invs'} component={InventoryOfOrg} />

        <PublicRoute path='/login' component={LoginPage} />
        <PublicRoute exact path={'/'} component={Home} />

        <PublicRoute exact path={'/products/:slug'} component={ProductDetails} />
        <PublicRoute path={'/product/:legacyId'} component={ProductLegacy} />
        <PublicRoute path={'/product/:legacyId/:anything'} component={ProductLegacy} />
        <PublicRoute exact path={'/brands/:slug'} component={BrandInfo} />
        <PublicRoute exact path={'/specialties/:slug'} component={CatProducts} />
        <PublicRoute exact path={'/groups/:slug'} component={Groups} />
        <PublicRoute exact path={'/compare/:slug'} component={CompareProducts} />
        <PublicRoute exact path={'/about'} component={About} />
        <PublicRoute exact path={'/terms'} component={Terms} />
        <PublicRoute exact path={'/privacy'} component={Privacy} />
        <PublicRoute path={'/search'} component={Search} />

        <PublicRoute component={NotFound} />

      </Switch>
    )
  }

  onLogoutClick() {
    //console.log('onLogoutClick');
    Controller.get().loginMgr().signOut();
    this.setState({
      currentUser: null
    })
  }

  onDashboardClick() {
    Controller.get().pushRoute('/admin');
  }

  getUserHomeLink = function () {
    return '/admin'
  }
}

const Styles = StyleSheet.create({
  page: {
  },
  header: {
    flex: '0 0 auto'
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
    paddingTop: AppTheme.toolbarHeight,
    overflowX: 'hidden',
    '@media(max-width: 767px)': {
      paddingTop: AppTheme.toolbarHeight * 1.9,
    },
  },
  footer: {
    flex: '0 0 auto'
  }
})

export default App;



// WEBPACK FOOTER //
// ./src/App.js